export default __webpack_public_path__ + "static/media/ip-link-outlined.64d36c29.svg";